import axiosHandler from "interceptor/axiosInterceptor";

export const getBookings = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/bookings", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBookingById = async (id) => {
  try {
    const response = await axiosHandler.get(`/api/admin/bookings/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateBookingStatus = async (id, status) => {
  try {
    const response = await axiosHandler.patch(`/api/admin/bookings/${id}/status`, {
      status,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPayouts = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/payouts", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updatePayoutStatus = async (id, status, transaction_ref) => {
  try {
    const response = await axiosHandler.patch(`/api/admin/payouts/${id}`, {
      status,
      transaction_ref,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
